export default {
  "root": "_root_19syn_1",
  "--animated": "_--animated_19syn_1"
};import "ni:sha-256;pGsqJm_vQ8-4jsIlTa3R5taMCpRulvDYXy5HBP3XztY";